import BasicPagination from './Basic.vue'
import Sorting from './Sorting.vue'

export default {
  install (Vue) {
    Vue.component('basic-pagination', BasicPagination)
    Vue.component('sorting', Sorting)
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination/index.js